import { createContext, useContext } from 'react';

export type JsMethodLoadingContextValue = {
  isAnyLoading: boolean;
  setLoading: (key: string, loading: boolean) => void;
};

const emptyLoadingContext: JsMethodLoadingContextValue = {
  isAnyLoading: false,
  setLoading: () => undefined,
};

export const JsMethodLoadingContext = createContext<JsMethodLoadingContextValue | null>(null);

export const useJsMethodLoading = (): JsMethodLoadingContextValue => {
  return useContext(JsMethodLoadingContext) ?? emptyLoadingContext;
};
